import {AsyncPipe, NgClass, NgFor, NgIf} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, map} from 'rxjs/operators';
import {
  ButtonComponent,
  DividerComponent,
  LabelComponent,
  ModalRef,
  SkeletonComponent,
} from '@sms-ir/ui-components';

import type {PlanPackageResult} from '@app/main/modules/plans/api/plan-api.models';
import {UserApiService} from '@app/main/modules/user-account/api/user-api.service';
import type {ApiResponse} from '@app/core/api';
import {PlanUtilsService} from '@app/shared/services/plan-utils.service';
import {
  PlanCardMeta,
  resolvePlanCardMetaByIndex,
} from '@app/main/modules/plans/constants/plan-card.constants';

import {CommaSeparatorPipe} from '@shared/pipes/comma-separator.pipe';
import {RialPipe} from '@shared/pipes/rial.pipe';

@UntilDestroy()
@Component({
  selector: 'app-plan-access-modal',
  standalone: true,
  imports: [RialPipe, CommaSeparatorPipe, 
    NgIf,
    NgFor,
    NgClass,
    AsyncPipe,    ButtonComponent,
    DividerComponent,
    LabelComponent,
    SkeletonComponent,
  ],
  templateUrl: './plan-access-modal.component.html',
  styleUrls: ['./plan-access-modal.component.scss'],
})
export class PlanAccessModalComponent implements OnInit {
  private readonly modalRef = inject<ModalRef<boolean>>(ModalRef);
  private readonly userApiService = inject(UserApiService);
  readonly _PlanUtilsService = inject(PlanUtilsService);

  planPackages$!: Observable<PlanPackageResult[]>;
  readonly skeletonCards = [0, 1, 2];

  ngOnInit(): void {
    this.planPackages$ = this.userApiService.getPlanPackages().pipe(
      untilDestroyed(this),
      filter((resp) => resp.success),
      map((resp: ApiResponse<PlanPackageResult[]>): PlanPackageResult[] => resp.result),
      map((result) => result.filter((f) => !f.plan.isFree)),
      map((result) => this.sortPlanPackages(result)),
    );
  }

  cardMeta(index: number): PlanCardMeta {
    return resolvePlanCardMetaByIndex(index + 1);
  }

  isFeatured(index: number): boolean {
    return this.cardMeta(index).tier === 'silver';
  }

  private sortPlanPackages(packages: PlanPackageResult[]): PlanPackageResult[] {
    return packages.sort((a: PlanPackageResult, b: PlanPackageResult) => a.plan.position - b.plan.position);
  }

  submit(): void {
    this.modalRef.close(true);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
